export interface Candidate {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  position: string;
  email: string;
  status: string;
  appliedDate: string;
  scheduledFor?: string | null;
  hasComments?: boolean;
}

export interface CandidateComment {
  id: string;
  comment: string;
  commentedBy?: string;
  date?: string;
}

export interface DragItem {
  id: string;
  currentStatus: string;
}

export const ItemTypes = {
  CANDIDATE: "candidate",
};
